<template>
    <v-row dense>
        <v-col cols="12" md="8">
            <p class="text-subtitle-1 font-weight-medium mb-4">{{ $t('hotel_room_amenities') }}:</p>

            <v-row dense>
                <v-col v-for="category in amenityCategories" :key="category" cols="12" class="mb-4">
                    <!-- Category Header -->
                    <div
                        class="pa-3 mb-3 text-center"
                        style="background-color: var(--zsh-primary-dark); color: white; border-radius: 4px"
                    >
                        <h4 class="text-subtitle-1 font-weight-medium">
                            {{ categoryNames[category] || category }}
                        </h4>
                    </div>

                    <!-- Category Amenities -->
                    <div class="px-2">
                        <v-checkbox
                            v-for="amenity in groupedAmenities[category]"
                            :key="amenity.id"
                            v-model="modelValue.roomAmenityEnabled[amenity.id]"
                            :label="localized(amenity.name)"
                            density="compact"
                            color="primary"
                            hide-details
                            :readonly="isFieldReadonly"
                            :data-cy="`amenity-${amenity.id}`"
                            class="mb-1"
                        />
                    </div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script setup lang="ts">
    const props = defineProps<{
        modelValue: any
        amenityCategories: string[]
        groupedAmenities: Record<string, any[]>
        categoryNames: Record<string, string>
        isFieldReadonly: boolean
        localized: (obj: any) => string
    }>()

    const emit = defineEmits<{
        (e: 'update:modelValue', value: any): void
    }>()

    const {t} = useI18n()
</script>
